module.exports = __webpack_public_path__ + "static/media/les.8f0471e0.svg";